import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "faqs"
    }}>{`FAQs`}</h1>
    <br></br>
    <h3 {...{
      "id": "q-what-is-the-advantage-of-using-swc"
    }}>{`Q: What is the advantage of using SWC?`}</h3>
    <p>{`A: Since SWC are built using Web Components, they are web-compatible. You can easily port your UI into web browsers.
Also, compared to Spectrum UXP Widgets, you can debug SWC like a standard Web Component.`}</p>
    <br></br>
    <h3 {...{
      "id": "q-can-i-use-spectrum-uxp-widgets-and-swc-with-other-frameworks-such-as-react"
    }}>{`Q: Can I use Spectrum UXP Widgets and SWC with other frameworks such as React?`}</h3>
    <p>{`A: Yes. These components are framework agnostic, and you can use them with any framework that works with UXP. Do note, however, that some frameworks do have special idioms for working with web components, so be sure to read the documentation for your framework. Check out the `}<a parentName="p" {...{
        "href": "../Spectrum%20UXP%20Widgets/Using%20with%20React/"
      }}>{`Use with React`}</a>{` section.`}</p>
    <p>{`A React wrapper for SWC is also in progress. A sample plugin will soon be added.`}</p>
    <br></br>
    <h3 {...{
      "id": "q-is-the-spectrum-uxp-widget-going-away"
    }}>{`Q: Is the Spectrum UXP widget going away?`}</h3>
    <p>{`A: No, but we are no longer adding new capabilities to these widgets.`}</p>
    <br></br>
    <h3 {...{
      "id": "q-the-tags-for-spectrum-uxp-widgets-and-swc-look-identical-how-do-i-differentiate"
    }}>{`Q: The tags for Spectrum UXP widgets and SWC look identical. How do I differentiate?`}</h3>
    <p>{`A: Certain components, such as `}<inlineCode parentName="p">{`<sp-button>`}</inlineCode>{` and `}<inlineCode parentName="p">{`<sp-link>`}</inlineCode>{`, are available as both - Spectrum UXP Widget and SWC. However, you should pay attention to the `}<inlineCode parentName="p">{`import`}</inlineCode>{` step needed by SWC. Once imported, UXP will assume you intend to use the SWC variation. `}</p>
    <br></br>
    <h3 {...{
      "id": "q-can-spectrum-uxp-widgets-and-swc-co-exist"
    }}>{`Q: Can Spectrum UXP widgets and SWC co-exist?`}</h3>
    <p>{`A: Yes. You can combine the two worlds seamlessly. For example,`}</p>
    <pre><code parentName="pre" {...{}}>{`<sp-banner> <!-- Spectrum Web Components -->
   <div slot="header">Header text</div>
   <div slot="content">Content of the banner</div>
</sp-banner>
<sp-dropdown placeholder="Select an option" style="width: 320px"> <!-- Spectrum UXP Widget -->
   <sp-menu slot="options">       
      <sp-menu-item> Option 1 </sp-menu-item>
      <sp-menu-item> Option 2 </sp-menu-item>
   </sp-menu>
</sp-dropdown>
`}</code></pre>
    <br></br>
    <h3 {...{
      "id": "q-are-spectrum-uxp-widgets-based-on-web-components-as-well"
    }}>{`Q: Are Spectrum UXP Widgets based on Web Components as well?`}</h3>
    <p>{`A: No. Although these widgets mimic the popular open-source Spectrum Web Components library, they are not built atop Web Components. In our old documentation, we had drawn parallelism with SWC because you will see a close similarity of the names and APIs between the two. Plus, the custom tags resemble the concept of Web Components in general. But, do not confuse them as Web Components.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      